import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';

import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '../../components';
import { EditListingDescriptionForm } from '../../forms';
import config from '../../config';
import { types as sdkTypes } from '../../util/sdkLoader';
import { updateProfile } from '../../containers/ProfileSettingsPage//ProfileSettingsPage.duck';
import { turnCustomerIntoProviderMaybe } from '../../containers/EditListingPage/utils';
const { Money } = sdkTypes;
import { getDescriptionKeywords, getPostsKeywords } from '../../util/editListing';
import { isMobileSafari } from '../../util/userAgent';

import css from './EditListingDescriptionPanel.module.css';

export class EditListingDescriptionPanelComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialValues: this.getInitialValues(),
      imageUploadRequested: false,
      showCrop: false,
      initialImages: [],
    };

    this.onImageUploadHandler = this.onImageUploadHandler.bind(this);
    this.handleSubmitFile = this.handleSubmitFile.bind(this);
    this.getInitialValues = this.getInitialValues.bind(this);
    this.submittedImages = [];
    this.isMobSaf = false;
  }

  componentDidMount() {
    this.isMobSaf = isMobileSafari();
    const { images } = this.props;

    if (this.compareImages()) {
      this.handleImages(images)
    }
  }

  componentDidUpdate(prevProps) {
    const { images } = this.props;

    if (this.compareImages()) {
      this.handleImages(images)
    }
  }

  imageIds(images) {
    return images &&
      images.length &&
      images
        .filter(image => image && (image.imageId || image.id && typeof image.id === 'object'))
        .map(image => image.imageId && image.imageId.uuid || image.id && image.id.uuid) || [];
  }

  handleImages(images) {
    const initialImages = this.imageIds(images);

    this.setState(
      { initialImages },
      // () => {
      //   form.change(
      //     'images',
      //     initialImages
      //   );
      // }
    )
  }

  onImageUploadHandler(file, imageKey) {
    const { onImageUpload, listing } = this.props

    if (file) {
      this.setState({ imageUploadRequested: true });
      onImageUpload({ id: `${Math.random().toFixed(4)}_${file.name}_${Date.now()}`, file, imageKey, listingId: listing?.id?.uuid, isDescriptionTab: true })
        .then((res) => {
          this.setState({ imageUploadRequested: false });
          return res
        })
        .catch(() => {
          this.setState({ imageUploadRequested: false });
        });
    }
  }

  compareImages() {
    const { images } = this.props;
    const { initialImages } = this.state;
    const prepearedImages = this.imageIds(images);

    return !isEqual(prepearedImages, initialImages);
  }

  handleSubmitFile(file, imageKey) {
    this.onImageUploadHandler(file, imageKey);
  }



  getInitialValues() {
    const { listing, currentUser, images } = this.props;
    const currentListing = ensureOwnListing(listing);
    const { description, title, publicData } = currentListing.attributes;

    // Only render current search if full place object is available in the URL params
    // TODO bounds are missing - those need to be queried directly from Google Places
    const locationFieldsPresent =
      publicData && publicData.location && publicData.location.address && geolocation;
    const location = publicData && publicData.location ? publicData.location : {};

    const dummyPrice = {
      price: new Money(0, config.currency),
    };

    const companyNameFromUserProfile = currentUser?.attributes?.profile?.publicData?.companyName;
    const websiteFromUserProfile = currentUser?.attributes?.profile?.publicData?.website;
    const addressFromUserProfile = currentUser?.attributes?.profile?.publicData?.address;
    const phoneNumberFromUserProfile = currentUser?.attributes?.profile?.publicData?.phoneNumber;
    const whatAreYouLookingForFromUserProfile =
      currentUser?.attributes?.profile?.publicData?.whatAreYouLookingFor;
    const whatYouDoFromUserProfile = currentUser?.attributes?.profile?.publicData?.whatYouDo;
    const userProviderType = currentUser?.attributes?.profile?.publicData?.providerType;

    const titleInitialValue = title || companyNameFromUserProfile;
    const websiteInitialValue = publicData.website || websiteFromUserProfile;
    const addressInitialValue = publicData.address || addressFromUserProfile;
    const phoneNumberInitialValue = publicData.phoneNumber || phoneNumberFromUserProfile;
    const whatAreYouLookingForInitialValue =
      publicData.whatAreYouLookingFor || whatAreYouLookingForFromUserProfile;
    const whatYouDoInitialValue = publicData.whatYouDo || whatYouDoFromUserProfile;

    const useDisplayName = publicData?.useDisplayName;
    const displayName = publicData?.displayName || currentUser?.attributes?.profile?.firstName;
    const displaySurname = publicData?.displaySurname || currentUser?.attributes?.profile?.lastName;

    const legalOtherDescription = Array.isArray(publicData?.legalOtherDescription) ? publicData?.legalOtherDescription : null;
    const marketingOtherDescription = Array.isArray(publicData?.marketingOtherDescription) ? publicData?.marketingOtherDescription : null;
    const insuranceOtherDescription = Array.isArray(publicData?.insuranceOtherDescription) ? publicData?.insuranceOtherDescription : null;
    const accountingOtherDescription = Array.isArray(publicData?.accountingOtherDescription) ? publicData?.accountingOtherDescription : null;
    const consultingOtherDescription = Array.isArray(publicData?.consultingOtherDescription) ? publicData?.consultingOtherDescription : null;
    const startupOtherDescription = Array.isArray(publicData?.startupOtherDescription) ? publicData?.startupOtherDescription : null;
    const otherOtherDescription = Array.isArray(publicData?.otherOtherDescription) ? publicData?.otherOtherDescription : null;

    const referralLink = publicData?.referralLink;

    const subcategoryPriceValues = publicData?.subcategoryPriceValues?.map(item => {
      return { key: item.key, min: item.min, max: item.max }
    })

    let initialValuesObj = {}

    subcategoryPriceValues?.map(item => {
      initialValuesObj[`subcategory-${item.key}-minPrice`] = item.min;
      initialValuesObj[`subcategory-${item.key}-maxPrice`] = item.max;
    })

    return {
      title: titleInitialValue,
      description,
      questions: publicData?.questions || [undefined],
      website: websiteInitialValue,
      address: addressInitialValue,
      phoneNumber: phoneNumberInitialValue,
      whatAreYouLookingFor: whatAreYouLookingForInitialValue,
      whatYouDo: whatYouDoInitialValue,
      productType: publicData.productType,
      category: publicData.category,
      subcategory: publicData.subcategory,
      geographicalFocus: publicData.geographicalFocus,
      companySize: Array.isArray(publicData?.companySize) && publicData?.companySize[0],
      operatingSince: Array.isArray(publicData?.operatingSince) && publicData?.operatingSince[0],
      shortDescription: publicData.shortDescription,
      serviceKeywords: publicData.serviceKeywords,
      paymentMethod: publicData.paymentMethod,
      providerType: userProviderType,
      startupAsk: publicData.startupAsk,
      fundingStatus: publicData.fundingStatus,
      paymnetAlternative: publicData.paymnetAlternative,
      useDisplayName: useDisplayName || null,
      displayName: displayName || null,
      displaySurname: displaySurname || null,
      images,
      referralLink,
      legalOtherDescription,
      marketingOtherDescription,
      insuranceOtherDescription,
      accountingOtherDescription,
      consultingOtherDescription,
      startupOtherDescription,
      otherOtherDescription,
      ...initialValuesObj
    };
  }

  render() {

    const {
      className,
      rootClassName,
      listing,
      disabled,
      ready,
      onSubmit,
      onChange,
      submitButtonText,
      isNewListingFlow,
      panelUpdated,
      updateInProgress,
      errors,
      currentUser,
      hasProviderMarker,
      onUpdateProfile,
      onLogoImageUpload,
      onRemoveImage,
      images,
      isDraftListing,
      onHandleValidatonPopup,
      onHandlePreviewPopup,
      onHandleCreateAndBublishListing,
      publishSuccess,
      isOffer
    } = this.props;

    const isClient =
      currentUser?.attributes?.profile?.publicData?.userType === 'client' && !hasProviderMarker;
    const isProvider =
      currentUser?.attributes?.profile?.publicData?.userType === 'service-provider';
    const classes = classNames(rootClassName || css.root, className);
    const currentListing = ensureOwnListing(listing);
    const { description, title, publicData } = currentListing.attributes;

    const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
    const panelTitle = isPublished ? (
      <FormattedMessage
        id="EditListingDescriptionPanel.title"
        values={{
          listingTitle: (
            <ListingLink listing={listing}>
              {isClient ? (
                <FormattedMessage id="EditListingDescriptionPanel.listingTitle" />
              ) : (
                'Provider profile'
              )}
            </ListingLink>
          ),
        }}
      />
    ) : isClient ? (
      <FormattedMessage id="EditListingDescriptionPanel.createListingTitle" />
    ) : (
      'Create provider profile'
    );

    const certificateOptions = findOptionsForSelectFilter('certificate', config.custom.filters);

    const dummyPrice = {
      price: new Money(0, config.currency),
    };

    const subscriptionLevel = +currentUser?.attributes?.profile?.privateData?.subscriptionProduct?.metadata?.level ||
    +currentUser?.attributes?.profile?.publicData?.subscriptionLevel || 1;

    const savedProviderVerified = publicData?.providerVerified || false;

    return (
      <div className={classes}>
        <h1 className={css.title}>{panelTitle}</h1>
        <EditListingDescriptionForm
          className={css.form}
          initialValues={this.state.initialValues}
          saveActionMsg={submitButtonText}
          onSubmit={values => {
            const {
              title,
              displayName,
              displaySurname,
              description,
              questions,
              website,
              address,
              phoneNumber,
              whatAreYouLookingFor,
              whatYouDo,
              productType,
              category,
              subcategory,
              geographicalFocus,
              companySize,
              operatingSince,
              shortDescription,
              serviceKeywords,
              paymentMethod,
              providerType,
              startupAsk,
              fundingStatus,
              paymnetAlternative,
              useDisplayName,
              referralLink,
              legalOtherDescription,
              marketingOtherDescription,
              insuranceOtherDescription,
              accountingOtherDescription,
              consultingOtherDescription,
              startupOtherDescription,
              otherOtherDescription,
            } = values;

            const subcategoryPriceValues = values?.subcategory?.map((item, i) => {
              const subcategoryOptions = findOptionsForSelectFilter('subcategory', config.custom.filters);
              const parentCategory = subcategoryOptions.filter(subCat => subCat.key === item)?.[0]?.category;

              return {
                key: values?.subcategory[i],
                min: values[`subcategory-${item}-minPrice`],
                max: values[`subcategory-${item}-maxPrice`],
                parentCategory
              }
            })

            const subcategoryOtherValues = values?.subcategory?.map((item, i) => values[`${item}Description`])?.filter(item => !!item)?.flat() || [];

            const subcategoryOtherValuesFormatted = subcategoryOtherValues?.map((item, i) => {

              return item
              .trim()
              .toLowerCase()
              .replace(/\n/g, '')
              .replace(/\t/g, '')
              .replace(/[(),.?!:#$"'_]/g, '')
              .split(' ')
              .filter(i => !!i)
              .filter(i => i.length > 2)
            }).flat()

            const minPriceArr = !!subcategoryPriceValues?.values && subcategoryPriceValues?.map(item => +item.min)
            const minPrice = !!minPriceArr?.length && Math.min.apply(Math, minPriceArr);
            const trimmedTitle = title.trim();
            const keywords = uniq([
              ...getDescriptionKeywords(
                values.title,
                values.description,
                values.category,
                values.subcategory,
                values.differentiationFromCompetitors
              ),
              ...getPostsKeywords(
                get(publicData, 'news', []),
                get(publicData, 'content', []),
                get(publicData, 'events', [])
              ),
            ]);

            const updateValues = {
              title: trimmedTitle,
              description,
              publicData: {
                keywords: !!subcategoryOtherValues?.length ? [...keywords, ...subcategoryOtherValuesFormatted] : keywords,
                questions,
                website,
                address,
                phoneNumber,
                whatAreYouLookingFor,
                whatYouDo,
                listingType: isClient ? 'client' : 'provider',
                productType,
                category,
                subcategory,
                subcategoryPriceValues,
                geographicalFocus,
                companySize: [companySize],
                operatingSince: [operatingSince],
                shortDescription,
                serviceKeywords,
                paymentMethod,
                providerType,
                startupAsk: providerType === 'startup' ? startupAsk : null,
                fundingStatus: providerType === 'startup' ? fundingStatus : null,
                paymnetAlternative,
                legalOtherDescription: legalOtherDescription?.length ? legalOtherDescription : null,
                marketingOtherDescription: marketingOtherDescription?.length ? marketingOtherDescription : null,
                insuranceOtherDescription: insuranceOtherDescription?.length ? insuranceOtherDescription : null,
                accountingOtherDescription: accountingOtherDescription?.length ? accountingOtherDescription : null,
                consultingOtherDescription: consultingOtherDescription?.length ? consultingOtherDescription : null,
                startupOtherDescription: startupOtherDescription?.length ? startupOtherDescription : null,
                otherOtherDescription: otherOtherDescription?.length ? otherOtherDescription : null,
                minPrice: !!minPrice || minPrice === 0 ? minPrice : null,
                useDisplayName: !!useDisplayName?.[0] ? useDisplayName : null,
                displayName: !!displayName?.trim() ? displayName : null,
                displaySurname: !!displaySurname?.trim() ? displaySurname : null,
                customDisplayName: !!useDisplayName?.[0] ? `${displayName} ${displaySurname} - ${title}` : null,
                referralLink: !!referralLink?.trim()?.length ? referralLink : null,
                subscriptionLevel: subscriptionLevel,
                providerVerified: isProvider ? savedProviderVerified : null
              },
              ...dummyPrice,
            };

            const profileImage = images?.filter(img => img?.imageId?.uuid)?.[0];
            const savedProfileImage = !!currentUser?.profileImage?.id?.uuid;
            return turnCustomerIntoProviderMaybe(hasProviderMarker)
            .then(() => {
              onUpdateProfile({
                publicData: {
                  companyName: !!useDisplayName?.[0] ? `${displayName} ${displaySurname} - ${title}` : title.trim(),
                  website,
                  address,
                  listingId: currentListing?.id?.uuid,
                  profileCompleted: true,
                  providerType,
                },
                profileImageId: !!profileImage ? profileImage?.imageId : savedProfileImage ? currentUser?.profileImage?.id : null,
                protectedData: { phoneNumber: !!phoneNumber?.trim()?.length ? phoneNumber : null }
              })
              onSubmit(updateValues);
            })
            .then(() => {
              return onUpdateProfile({
                publicData: {
                  referralLink: !!referralLink?.trim()?.length ? referralLink : null,
                  profileCompleted: true,
                  companyName: !!useDisplayName?.[0] ? `${displayName} ${displaySurname} - ${title}` : title.trim(),
                  website,
                  address,
                  listingId: currentListing?.id?.uuid,
                  providerType,
                },
                protectedData: { phoneNumber: !!phoneNumber?.trim()?.length ? phoneNumber : null },
              });
            })
            .catch(err => {
              console.log(err);
            });
          }}
          onChange={onChange}
          disabled={disabled}
          ready={ready}
          updated={panelUpdated}
          updateInProgress={updateInProgress}
          fetchErrors={errors}
          certificateOptions={certificateOptions}
          isClient={isClient}
          isNewListingFlow={isNewListingFlow}
          isDraftListing={isDraftListing}
          currentUser={currentUser}
          onLogoImageUpload={onLogoImageUpload}


          showCrop={this.state.showCrop}
          isMobSaf={this.isMobSaf}
          publicData={publicData}
          imageUploadRequested={this.state.imageUploadRequested}
          onImageUploadHandler={this.onImageUploadHandler}
          onRemoveImage={onRemoveImage}
          handleSubmitFile={this.handleSubmitFile}
          handleCloseCropPopup={() => this.setState({ showCrop: false })}
          images={images}
          onHandleValidatonPopup={onHandleValidatonPopup}
          onHandlePreviewPopup={onHandlePreviewPopup}
          onHandleCreateAndBublishListing={onHandleCreateAndBublishListing}
          listing={listing}
          publishSuccess={publishSuccess}
          description={description}
        />
      </div>
    );
  }
}

EditListingDescriptionPanelComponent.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingDescriptionPanelComponent.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const EditListingDescriptionPanel = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EditListingDescriptionPanelComponent);

export default EditListingDescriptionPanel;
